<template>
  <span :class="[class_name,{athena_num:theme=='athena',big_num:$store.state.cartContentsCount>99}]">{{(this.$store.state.cartContentsCount>99?'99+':this.$store.state.cartContentsCount) || 0}}</span>
</template>
<script>
export default {
  props:['class_name','theme'],
  beforeMount() {
    let cartContentsCount = localStorage.getItem("cartContentsCount");
    if (cartContentsCount&& cartContentsCount!='undefined') {
      this.$store.dispatch("cartContentsCount", cartContentsCount);
    } else {
      this.$store.dispatch("cartContentsCount", 0);
      localStorage.setItem("cartContentsCount", 0);
    }
  }
};
</script>
<style scoped lang='scss'>
.athena_num {
  background-color: #FF7538 !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
  left: 14px !important;
  top: 20px !important;
}
#app .athena_num.big_num {
  width: 32px !important;
  border-radius: 8px;
}
@media screen and (max-width: 768px) {
  .athena_num {
  width: 14px !important;
  height: 14px !important;
  line-height: 15px !important;
  left: 11px !important;
  top: 14px !important;
}
  #app .athena_num.big_num {
    width: 28px !important;
    border-radius: 7px;
    left: 15px !important;
  }
}
#app .big_num {
  width: 40px;
  border-radius: 10px;
}
</style>
